const onloadElements = ['body', 'frame', 'iframe', 'img', 'link', 'script', 'style'];
/**
 * Добавляет в head тег
 * @return {Promise}
 */
export function loadTagAsync(tag) {
    return new Promise(resolve => {
        const newElement = tag.toHTMLElement();
        if (onloadElements.indexOf(tag.type) > -1) {
            newElement.onload = () => {
                resolve();
            };
        }
        else {
            resolve();
        }
        document.head.appendChild(newElement);
    });
}
